<div>
  <app-main-view-configurator [typeOfFurniture]="typeOfFurniture" [brandLogoPath]="brandLogoPath"
    [showPricing]="showPricing"></app-main-view-configurator>
</div>